module.exports = __webpack_public_path__ + "img/finansowanie-img.8402df17.png";